module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "zan-steps",
    class: ("zan-steps--" + (_vm.steps.length))
  }, [(_vm.icon) ? _c('div', {
    staticClass: "zan-steps__status"
  }, [_c('i', {
    staticClass: "zan-icon zan-steps__icon",
    class: _vm.computedIconClass
  }), _vm._v(" "), _c('div', {
    staticClass: "zan-steps__message"
  }, [_c('div', {
    staticClass: "zan-steps__message-wrapper"
  }, [_c('h4', {
    staticClass: "zan-steps__title",
    domProps: {
      "textContent": _vm._s(_vm.title)
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "zan-steps__desc",
    domProps: {
      "textContent": _vm._s(_vm.description)
    }
  })])]), _vm._v(" "), _vm._t("message-extra")], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "zan-steps__items"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-65d072bb!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/steps/src/steps.vue
// module id = 172
// module chunks = 0 2